import { createSelector } from "reselect";

const getStory = (state) => state.story;
const getActiveChapterId = (state, ownProps) => ownProps.activeChapterId;

const getActiveChapterEntity = createSelector(
  getActiveChapterId,
  getStory,
  (activeChapterId, story) => {
    if (!activeChapterId) {
      return;
    }

    const chapterSchema = story.chapters.find(
      ({ id }) => id === activeChapterId,
    );
    if (!chapterSchema) {
      throw Error("Chapter not found");
    }
    return story.entities[chapterSchema.schema][chapterSchema.id];
  },
);

export default getActiveChapterEntity;
